<template>
    <ul
        v-qa="'loading-animation'"
        class="loading-animation"
    >
        <li class="item round"></li>
        <li class="item emerald"></li>
        <li class="item heart"></li>
        <li class="item oval"></li>
        <li class="item hexagonal"></li>
    </ul>
</template>

<style lang="scss" scoped>
.loading-animation {
    width: 100%;
    position: relative;
    list-style: none;
    padding: 20px 0;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    @include min-width(640) {
        padding: 40px 0;
        height: 140px;
    }

    .item {
        width: 20px;
        height: 20px;
        margin: 0 10px;

        @include min-width(640) {
            width: 30px;
            height: 30px;
            margin: 0 20px;
        }

        &::before {
            font-family: $icon-font;
            width: 20px;
            height: 20px;
            display: block;
            font-size: 20px;
            text-align: center;
            line-height: 20px;

            @include min-width(640) {
                width: 30px;
                height: 30px;
                line-height: 30px;
                font-size: 30px;
            }
        }

        &.round {
            animation: blink 2s infinite linear;

            &::before {
                content: $icon-shape-round;
            }
        }

        &.emerald {
            animation: inverted-blink 1.5s infinite linear;

            &::before {
                content: $icon-shape-emerald;
            }
        }

        &.oval {
            animation: blink 1.5s infinite linear;

            &::before {
                content: $icon-shape-oval;
            }
        }

        &.hexagonal {
            animation: inverted-blink 2s infinite linear;

            &::before {
                content: $icon-shape-hexagonal;
            }
        }

        &.heart {
            animation: blink 2.5s infinite linear;

            &::before {
                content: $icon-shape-heart;
            }
        }
    }
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    33% {
        opacity: 0.25;
    }

    100% {
        opacity: 1;
    }
}

@keyframes inverted-blink {
    0% {
        opacity: 0.25;
    }

    66% {
        opacity: 1;
    }

    100% {
        opacity: 0.25;
    }
}
</style>
